import { supabase } from '../lib/supabaseClient';

export async function verifyUserCount() {
  console.log('🔍 Verificando conteo de usuarios...');
  
  try {
    // Get all profiles with detailed info
    const { data: profiles, error } = await supabase
      .from('profiles')
      .select('id, email, full_name, role, created_at')
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error('❌ Error:', error);
      return;
    }
    
    console.log('\n📊 RESULTADOS:');
    console.log('Total registros en profiles:', profiles?.length || 0);
    
    // Check for unique emails
    const emailSet = new Set();
    const uniqueUsers: any[] = [];
    const duplicates: any[] = [];
    
    profiles?.forEach((profile: any) => {
      if (profile.email) {
        if (emailSet.has(profile.email)) {
          duplicates.push(profile);
        } else {
          emailSet.add(profile.email);
          uniqueUsers.push(profile);
        }
      }
    });
    
    console.log('Emails únicos:', emailSet.size);
    console.log('Usuarios únicos:', uniqueUsers.length);
    console.log('Duplicados encontrados:', duplicates.length);
    
    console.log('\n👥 USUARIOS ÚNICOS:');
    uniqueUsers.forEach((user, index) => {
      console.log(`${index + 1}. ${user.email} (${user.role || 'user'}) - ID: ${user.id.slice(0, 8)}...`);
    });
    
    if (duplicates.length > 0) {
      console.log('\n⚠️  DUPLICADOS:');
      duplicates.forEach((dup, index) => {
        console.log(`${index + 1}. ${dup.email} (${dup.role || 'user'}) - ID: ${dup.id.slice(0, 8)}...`);
      });
    }
    
    // Check auth.users table for comparison
    const { data: authUsers, error: authError } = await supabase.auth.admin.listUsers();
    
    if (!authError && authUsers) {
      console.log('\n🔐 AUTH.USERS:');
      console.log('Total usuarios en auth.users:', authUsers.users.length);
      authUsers.users.forEach((user, index) => {
        console.log(`${index + 1}. ${user.email} - ID: ${user.id.slice(0, 8)}...`);
      });
    }
    
  } catch (error) {
    console.error('❌ Error verificando usuarios:', error);
  }
}

// Make it available globally
(window as any).verifyUserCount = verifyUserCount;